import http from "../services/http"

class CorreiosService {

    async getZipcode(data) {

        return await http.post('get/correios/', data)
    }
}

const correiosService = new CorreiosService()

export default correiosService
